module.exports = __webpack_public_path__ + "static/media/sklearn_genetic_opt.23273bc8.png";